module.exports = __webpack_public_path__ + "static/media/CAKE-BNB.cb918706.svg";